module.exports = __webpack_public_path__ + "static/businness-card-2-155cfa6c1832d6a8731f163b1d53210f.jpg";